import { get, put } from "@/shared/utils/fetchApi";

export interface PlaygroundConfig {
  rag: {
    similarityThreshold: number;
    maxResults: number;
    temperature: number;
    maxTokens: number;
    roleSystem: string;
    metadataFilters: object;
  };
  ui: {
    welcomeMessage: string;
    placeholder: string;
    maxChatHistory: number;
  };
  restrictions: {
    allowedFileTypes: string[];
    maxQueryLength: number;
    rateLimitPerMinute: number;
  };
}

export interface PlaygroundConfigResponse {
  success: boolean;
  data: PlaygroundConfig;
}

export class PlaygroundConfigService {
  private static readonly BASE_URL = "/playground/config";

  /**
   * Obter configurações do Playground para um produto
   */
  static async getConfig(
    workspaceId: string,
  ): Promise<PlaygroundConfigResponse> {
    return get<PlaygroundConfigResponse>(`${this.BASE_URL}/${workspaceId}`);
  }

  /**
   * Atualizar configurações do Playground para um produto
   */
  static async updateConfig(
    workspaceId: string,
    config: Partial<PlaygroundConfig>,
  ): Promise<PlaygroundConfigResponse> {
    return put<PlaygroundConfigResponse>(
      `${this.BASE_URL}/${workspaceId}`,
      config,
    );
  }
}
